import { render, staticRenderFns } from "./ExpandIcon.vue?vue&type=template&id=09d5864e&scoped=true"
import script from "./ExpandIcon.vue?vue&type=script&lang=js"
export * from "./ExpandIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d5864e",
  null
  
)

export default component.exports